module.exports = __webpack_public_path__ + "img/zs2.b8f15a73.png";